import { render, staticRenderFns } from "./PortraitLevel3.vue?vue&type=template&id=153afe34&scoped=true"
import script from "./PortraitLevel3.vue?vue&type=script&lang=js"
export * from "./PortraitLevel3.vue?vue&type=script&lang=js"
import style0 from "./PortraitLevel3.vue?vue&type=style&index=0&id=153afe34&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153afe34",
  null
  
)

export default component.exports